quoteModule.controller('lendersInfoController',
    ['$scope', '$rootScope', '$mdDialog', 'erateSessionVarsService', 'lenderRetrievalService','TLCError','AppErrorCodes', 'imSessionVarsService', '$window',
        function ($scope, $rootScope, $mdDialog, erateSessionVarsService,lenderRetrievalService, TLCError, AppErrorCodes, imSessionVarsService, $window) {
            var self = this;

            //Lenders data
            $scope.lenders = [];


            init();

            function init() {
                //retrieve the dealership's lenders
                lenderRetrievalService.retrieveLenders()
                        .then(
                        function (lendersData) {
                            $scope.lenders = lendersData;
                            if (imSessionVarsService.getShowcaseIntegrated() == 'true' && imSessionVarsService.getShowcaseIntegratedSetting() == 'Lenders')
                                $scope.open();
                        },
                        function (err) {
                            throw new TLCError(new Error(err),AppErrorCodes.LenderController_LoadLendersError);
                        });
            };

            // Calling the modal to add/update lender
            $scope.open = function (event, lenderId) {
                $mdDialog.show( {
                    controller: 'lendersModalInstanceController',
                    templateUrl: 'app/modules/quote/views/lenders-modal.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    controllerAs: 'ctrl',
                    bindToController: true,
                    locals: { lenderId: lenderId  }
                });

                if (event) {
                    event.stopPropagation();
                }
            };

            // When updates/additions are made, we need to refresh the lenders list
            $scope.$on('refreshLenders', function () {
                if (imSessionVarsService.getShowcaseIntegrated() == 'true' && imSessionVarsService.getShowcaseIntegratedSetting() == 'Lenders')
                    $window.close();
                else
                    init();
            });

            $scope.lenderCodeName = function(name, code)
            {
                if(code.length > 0)
                {
                   return   name + " (" + code + ")";
                }
                else {
                    return name;
                }
            }

            //delete a lender
            $scope.deleteLender = function (lenderId, lenderName) {
                var deleteLender =
                    confirm('Are you sure you want to delete the lender?');
                if (deleteLender) {
                    lenderRetrievalService.deleteLenderById(lenderId)
                        .then(
                        function (response) {
                            init();
                        }, function (err) {
                            throw new TLCError(new Error(err),AppErrorCodes.LenderController_DeleteLendersError);
                        });

                }
            }

}]);
